{
    "keys": {
        "common": {
            "action_timestamp": "Action date",
            "organization_legal_name": "Organization name",
            "action_type": "Action type",
            "user_email": "User email",
            "outcome": "Outcome",
            "before": "Initial value",
            "after": "Final value"
        },
        "pos_terminals": {
            "serial_number": "Serial number",
            "manufacturer": "Manufacturer",
            "label": "POS terminal label",
            "custom_label": "POS terminal label 2"
        },
        "sim_cards": {
            "iccid": "SIM number"
        },
        "users": {
            "email": "Users",
            "type": "Type"
        }
    },
    "filter": {
        "placeholder": {
            "common": {
                "organization_legal_name": "Filter by organization name",
                "user_email": "Filter by user email"
            },
            "pos_terminals": {
                "serial_number": "Filter by serial number",
                "manufacturer": "Filter by manufacturer",
                "label": "Filter by POS terminal label",
                "custom_label": "Filter by POS terminal label 2"
            },
            "sim_cards": {
                "iccid": "Filter by SIM number"
            },
            "users": {
                "email": "Filter by users"
            }
        }
    },
    "status": {
        "outcome": {
            "success": "Success",
            "failure": "Failure"
        }
    },
    "actions": {
        "pos_terminals": {
            "IP_SUBSCRIPTION_ACTIVATION": "IP subscription activation",
            "IP_SUBSCRIPTION_MULTIPLE_ACTIVATION": "Multiple POS terminal activation",
            "REWAREHOUSE": "Return to stock",
            "BLACKLIST_ADD": "Blacklist TPE",
            "BLACKLIST_ADD_MULTIPLE": "Multiple blacklist TPE",
            "MIGRATE": "Migration",
            "IP_SUBSCRIPTION_TERMINATE": "IP subscription termination",
            "BLACKLIST_REMOVE": "POS terminal authorization",
            "LABEL_UPDATE": "POS terminal label update",
            "BLACKLIST_ADD_TEMPORARY": "Temporary POS terminal authorization",
            "DISSOCIATE_SIM": "SIM card dissociation",
            "ASSOCIATE_SIM": "SIM card association",
            "UPDATE_IP_OFFER": "IP offer update"
        },
        "sim_cards": {
            "UPDATE_SIM_LABEL": "SIM label update",
            "UPDATE_SIM_OFFER": "SIM offer update",
            "ACTIVATE_SIM": "SIM activation",
            "REACTIVATE_SIM": "SIM reactivation",
            "SUSPEND_SIM": "SIM suspension",
            "TERMINATE_SIM": "SIM termination",
            "DISSOCIATE_POS_TERMINAL": "POS terminal dissociation",
            "ASSOCIATE_POS_TERMINAL": "POS terminal association",
            "ASK_REPLACE_SIM": "Ask replace SIM",
            "SIM_REPLACE": "SIM replacement"
        },
        "users": {
            "MANAGEMENT_USER_CREATION": "Add new monetic user",
            "MERCHANT_USER_CREATION": "Add new merchant user",
            "USER_LOGIN_AS": "Connect as",
            "USER_PERMISSIONS": "Modify user permission",
            "USER_ACTIVATION": "Activate user",
            "USER_DEACTIVATION": "Deactivate user",
            "USER_REMOVAL": "Delete user",
            "USER_EMAIL_ACTIVATION_RESENDING": "Forward monetic user mail"
        },
        "row": {
            "details": "Details"
        }
    },
    "tooltip": {
        "user_initiator": "{{userInitiator}} connected as {{userAccountUpdated}}"
    },
    "cells": {
        "modification_count_one": "{{count}} modification",
        "modification_count_other": "{{count}} modifications",
        "no_user": "Unknown",
        "no_permission_modified": "No permission modified"
    },
    "users": {
        "MANAGEMENT": "Monetic user",
        "MERCHANT": "Merchant user"
    },
    "modal": {
        "details": {
            "title": "Details of historic",
            "action": "Action: ",
            "initial": "Initial value:",
            "final": "Final value:",
            "no_value": "No value"
        }
    }
}